import moment from "moment";
import { UrlApi } from "../../../../../services/apirest";

export const conciliarPagos = async (ids) => {
  try {
    // Obtener usuario del localStorage
    const user = localStorage.getItem('user');
    const fechaHora = moment(new Date()).format("YYYY-MM-DD HH:mm:ss")

    const response = await fetch(`${UrlApi}/envasado_pagos_combinados/conciliar`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 
        ids,
        usuario: user || 'sistema',
        fechaHora: fechaHora
      }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || `Error: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error al conciliar pagos:', error);
    throw error;
  }
};

export const quitaConciliacion = async (ids) => {
  try {
    const user = localStorage.getItem('user');
    const fechaHora = moment(new Date()).format("YYYY-MM-DD HH:mm:ss")

    const response = await fetch(`${UrlApi}/envasado_pagos_combinados/quita-conciliacion`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ids,
        usuario: user || 'sistema',
        fechaHora: fechaHora
      }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || `Error: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error al desconciliar pagos:', error);
    throw error;
  }
};